// extracted by mini-css-extract-plugin
module.exports = {"numinput":"numberinput_numinput__2fI3H"};